module.exports = __webpack_public_path__ + "img/IMG_2729_L_Black_MockedUp.461e234e.jpg";